import {
  createProductSeller,
  loginSellerAccount,
  logout,
  registerSellerAccount,
  taxDetailsRegistration,
  updateUserProfile,
} from "../../api";
import {
  CREATE_SELLER_ACCOUNT_LOGIN_REQUEST,
  CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS,
  CREATE_SELLER_ACCOUNT_LOGIN_FAIL,
  USER_LOGOUT,
  CREATE_TAX_REGISTRATION_REQUEST,
  CREATE_TAX_REGISTRATION_SUCCESS,
  CREATE_TAX_REGISTRATION_FAIL,
  CREATE_SELLER_ACCOUNT_REQUEST,
  CREATE_SELLER_ACCOUNT_SUCCESS,
  CREATE_SELLER_ACCOUNT_FAIL,
  SEND_OTP_FAIL,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  UPDATE_USER_DETAILS_REQUEST,
  UPDATE_USER_DETAILS_SUCCESS,
  UPDATE_USER_DETAILS_FAIL,
  CLEAR_ERRORS,
} from "../Constants/userContants";

export const sellerAccountRegistration = (details) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_SELLER_ACCOUNT_REQUEST });

    const { data } = await registerSellerAccount(details);
    console.log(data);

    dispatch({ type: CREATE_SELLER_ACCOUNT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_SELLER_ACCOUNT_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const registrationTaxDetails = (details) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_TAX_REGISTRATION_REQUEST });

    const { data } = await taxDetailsRegistration(details);
    console.log(data);

    dispatch({ type: CREATE_TAX_REGISTRATION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_TAX_REGISTRATION_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const sellerAccountLogin = (details) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_SELLER_ACCOUNT_LOGIN_REQUEST });

    const { data } = await loginSellerAccount(details);
    console.log(data);

    dispatch({ type: CREATE_SELLER_ACCOUNT_LOGIN_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_SELLER_ACCOUNT_LOGIN_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    const { data } = await logout();
    console.log(data);

    dispatch({ type: USER_LOGOUT, payload: data });
  } catch (error) {
    dispatch({
      type: SEND_OTP_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const updateUserDetails = (details) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_USER_DETAILS_REQUEST });

    const { data } = await updateUserProfile(details);

    dispatch({ type: UPDATE_USER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_DETAILS_FAIL,
      payload: error.response.data.message,
    });
  }
};

export const createProduct = (details) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PRODUCT_REQUEST });
    console.log(details);
    const { data } = await createProductSeller(details);
    console.log(data);

    dispatch({ type: CREATE_PRODUCT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CREATE_PRODUCT_FAIL,
      payload: error.response.data.message,
    });
  }
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
};
